import { createFileRoute, redirect } from '@tanstack/react-router'

// Unpublished — see resources.tsx.
export const Route = createFileRoute('/resources_/$slug')({
  beforeLoad: () => {
    throw redirect({ to: '/', statusCode: 301 })
  },
})
